<template>
  <b-card
    class="timesheets-inputs"
    body-class="py-0 flex-column d-flex"
    header-class="bg-transparent border-bottom-0"
    footer-class="bg-transparent border-top-0 py-0"
  >

    <template #header>
      <b-button class="w-100 my-4" variant="outline-success" size="md" @click="printDetails" >printDetails</b-button>
      <h4 class="text-primary text-uppercase font-weight-bold text-center">
        {{$t($getConst.pages.timesheet.total_time)}}
      </h4>
    </template>


    <TimesheetTimeInput                                         :unit="unit" is-plaintext :label="overtimeTypes.std" :value="stdTotal" :timesheetStd="timesheetStd"/>
    <TimesheetTimeInput v-if="isToDisplayOvertime(1)" :unit="unit" is-plaintext :label="overtimeTypes.ot1" :value="ot1Total" :timesheetStd="timesheetStd"/>
    <TimesheetTimeInput v-if="isToDisplayOvertime(2)" :unit="unit" is-plaintext :label="overtimeTypes.ot2" :value="ot2Total" :timesheetStd="timesheetStd"/>
    <TimesheetTimeInput v-if="isToDisplayOvertime(3)" :unit="unit" is-plaintext :label="overtimeTypes.ot3" :value="ot3Total" :timesheetStd="timesheetStd"/>
    <div v-if="absenceTotal != null && absenceTotal>0 && (!isApprover('L1'))">
      <h4 class="text-primary text-uppercase font-weight-bold text-center">
        {{$t($getConst.pages.timesheet.total_absences)}}
      </h4>
      <TimesheetTimeInput :unit="'day'" is-plaintext label="" :value="absenceTotal" :unitAbsences="unitAbsences" :timesheetStd="timesheetStd"/>
    </div>

    <b-form-group :label="$t($getConst.pages.timesheet.globalComment)"
                  class="mt-auto" label-class="text-primary" label-for="comment-input">
      <b-form-textarea
        id="comment-input"
        v-model="$v.commentTotal.$model"
        :disabled="isApprover() || timesheet.Status === $getConst.timesheetsStatus.submitted"
        :class="{ 'is-invalid': $v.commentTotal.$error }"
        size="lg"
        @input="updateTimesheetCommentTotal"
      ></b-form-textarea>
      <AppFormFeedback :errors="$v.commentTotal"/>

    </b-form-group>
    <AppFormFileInput
      v-if="timesheetsConfig.has_attachment  && isApprover('L1')==false "
      v-model="files"
      class="mx-auto"
      label="Upload supporting files"
      @input="inputFileRecive"
      :timesheetAttachements="oldAttachments"
      :timesheetForm= "timesheet"
      :multipleFile="true"
      :timesheetsConfig="timesheetsConfig"
    />

     <b-link v-if="((isWorker() || isFreelancer()) && !(timesheet.Status === $getConst.timesheetsStatus.processed
      || timesheet.Status === $getConst.timesheetsStatus.submitted
      || timesheet.Status === $getConst.timesheetsStatus.approved ))" class="mt-3 mb-2 text-center" id="file_types">
       {{$t($getConst.pages.timesheet.check_the_supported_files_list)}}
     </b-link>
    <b-tooltip target="file_types" variant="secondary">
      <h5 style="text-decoration-line: underline">{{$t($getConst.pages.timesheet.allowed_extensions)}}</h5>
       jpeg, jpg, png, pdf, xlsx, xls, dot, doc, docx, eml
    </b-tooltip>

    <template #footer v-if="!$store.getters['auth/isLoggedAs']">

      <TimesheetConfirmButtons
        v-if="submitFromForm"
        :timesheet="timesheet"
        :timesheetStd="timesheetStd"
      />

    </template>

  </b-card>
</template>

<script>
  import TimesheetTimeInput from "./TimesheetTimeInput";
  import AppFormFileInput from "../../../components/common/form/AppFormFileInput";
  import TimesheetConfirmButtons from "./TimesheetConfirmButtons";
  import {maxLength} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import {getTimesheetsConfig} from "../../../api/timesheet.api";
  import jsPDF from "jspdf";
  import images from "../../../shared/constants/images"
  import verdana from "./Verdana"

  export default {
    name: "TimesheetTotalHours",
    components: {TimesheetConfirmButtons, AppFormFileInput, TimesheetTimeInput, AppFormFeedback},
    props: {
      timesheet: null,
      submitFromForm: {
        type: Boolean,
        default: true
      },
      unitAbsences:{
        type: String,
        default: null
      },
      timesheetStd:null
    },
    data() {
      return {
        unit: null,
        stdTotal: null,
        ot1Total: null,
        ot2Total: null,
        ot3Total: null,
        commentTotal: null,
        files:[],
        absenceTotal: null,
        oldAttachments: [],
        timesheetsConfig: {
          has_attachment:null
        }
      }
    },
    validations: {
      commentTotal: {maxLength: maxLength(100)},
    },
    methods: {
      printDetails() {
        const doc = new jsPDF('portrait', 'px', 'a4');
        const font = verdana.verdana;
        doc.addFileToVFS("Verdana.ttf", font);
        doc.addFont("Verdana.ttf", "Verdana", "normal");
        doc.setFont("Verdana");
        doc.setProperties({
          title: 'Timesheet'
        });
        let tableWidth = 230
        let tableHead = ""
        let totalStr = ""
        let spanStyle = 'style="font-weight: bolder"'

        let strHeaderStyle=' style="font-size: 8px; text-align:center"'
        if (this.timesheet.Days.Types[0].ot1!=="OVERTIME1"){
          tableWidth += 20
          tableHead+=`<th ${strHeaderStyle}>${this.timesheet.Days.Types[0].ot1}</th>`
          totalStr+=`<div>${this.timesheet.Days.Types[0].ot1}: <span ${spanStyle}>${this.ot1Total} ${this.getUnit()}</span></div>`
        }
        if (this.timesheet.Days.Types[0].ot2!=="OVERTIME2"){
          tableWidth += 20
          tableHead+=`<th ${strHeaderStyle}>${this.timesheet.Days.Types[0].ot2}</th>`
          totalStr+=`<div>${this.timesheet.Days.Types[0].ot2}: <span ${spanStyle}>${this.ot2Total} ${this.getUnit()}</span></div>`
        }
        if (this.timesheet.Days.Types[0].ot3!=="OVERTIME3"){
          tableWidth += 20
          tableHead+=`<th ${strHeaderStyle}>${this.timesheet.Days.Types[0].ot3}</th>`
          totalStr+=`<div>${this.timesheet.Days.Types[0].ot3}: <span ${spanStyle}>${this.ot3Total} ${this.getUnit()}</span></div>`
        }
        tableWidth += 80
        tableHead+=`<th ${strHeaderStyle}>ABSENCES</th>`
        tableHead+=`<th ${strHeaderStyle}>ABS CODE</th>`

        let str_calendar =``
        str_calendar+= this.getMainDetails()
        str_calendar+=`
        <div style="width: 250px; font-weight: bolder; font-size: 10px; margin-top: 5px">Timesheet Detail</div>
        <table border="1" width="${tableWidth}">
          <thead>
            <tr>
              <th ${strHeaderStyle}>Date</th>
              <th ${strHeaderStyle}>${this.timesheet.Days.Types[0].std}</th>
              ${tableHead}
              <th ${strHeaderStyle}>Remarks</th>
            </tr>
          </thead>
          <tbody>`;
        str_calendar+= this.generateCalBody()
        str_calendar+= `</tbody></table>`
        str_calendar+= this.totalBlock(totalStr)
        doc.html(str_calendar, {
          callback: function (doc) {
            doc.save("Timesheet");
          },
          x: 40,
          y: 20,
        });
      },
      getMainDetails() {

        let approverName = ""
        let approverDate = ""
        let approver = this.timesheet.Approvers.find(ap=>ap.date!==null)
        if (approver){
          approverName = approver.name
          approverDate = approver.date
        }
        let strLabelStyle = 'style="font-weight: bolder; font-size: 9px"'
        let strLabelVal = 'style="font-family: \'Verdana\';font-size: 9px"'
        let tdStyle =  'style="line-height:0.9"'
        return `
        <table border="0" width="350" style="padding: 2px">
          <body>
            <tr>
                <td ${tdStyle}><img src="${images.logo_wide}"  alt="" width="100px"/></td>
                <td</td>
            </tr><tr>
                <td ${tdStyle}><span ${strLabelStyle}>Timesheet ID:</span> <span ${strLabelVal}>${this.timesheet.ID}</span></td>
                <td rowspan="2" style="font-weight: bolder; font-size: 14px; text-align: center">Hays Timesheet</td>
            </tr><tr>
                <td ${tdStyle}><span ${strLabelStyle}>Status:</span> <span ${strLabelVal}> ${this.timesheet.Status}</span></td>
            </tr><tr>
                <td ${tdStyle}><span ${strLabelStyle}>Start date:</span> <span ${strLabelVal}> ${this.timesheet.TimesheetStartDate}</span></td>
                <td ${tdStyle}></td>
            </tr><tr>
                <td ${tdStyle}><span ${strLabelStyle}>End date:</span> <span ${strLabelVal}> ${this.timesheet.TimesheetEndDate}</span></td>
                <td ${tdStyle}><span ${strLabelStyle}>Approver:</span> <span ${strLabelVal}> ${approverName}</span></td>
            </tr><tr>
                <td ${tdStyle}><span ${strLabelStyle}>Contract: </span> <span ${strLabelVal}>${this.timesheet.ContractID}</span></td>
                <td ${tdStyle}><span ${strLabelStyle}>Approval Date:</span> <span ${strLabelVal}> ${approverDate} </span></td>
            </tr><tr>
                <td ${tdStyle}><span ${strLabelStyle}>Worker:</span> <span ${strLabelVal}> ${this.timesheet.WorkerName}</span></td>
                <td ${tdStyle}><span ${strLabelStyle}>Customer Name:</span> <span ${strLabelVal}> ${this.timesheet.CompanyName}</span></td>
            </tr>
          </body>
         </table>`
      },
      generateCalBody() {
        let calendarHTML = '';
        let strStyle=' style="font-size: 7px;"'
        let strStyleRemark=' style="font-family: \'Verdana\';font-size: 8px;line-height:0.9"'
        this.timesheet.Days.Days.forEach((day, index)=> {
          let extra =""
          if (
              !(day.Remarks===null &&
              day.absenceQty==="0" &&
              day.absenceCode==="" &&
              day.absenceQty==="0" &&
              day.ot1==="0.00" &&
              day.ot2==="0.00" &&
              day.ot3==="0.00" &&
              day.std==="0.00")
          ){
            if (this.timesheet.Days.Types[0].ot1!=="OVERTIME1"){
              extra += `<td ${strStyle}>${this.getDateData(index,'ot1')}</td>`;
            }
            if (this.timesheet.Days.Types[0].ot2!=="OVERTIME2"){
              extra += `<td ${strStyle}>${this.getDateData(index,'ot2')}</td>`;
            }
            if (this.timesheet.Days.Types[0].ot3!=="OVERTIME3"){
              extra += `<td ${strStyle}>${this.getDateData(index,'ot3')}</td>`;
            }
            calendarHTML += `
            <tr>
              <td ${strStyle}>${day.date}</td>
              <td ${strStyle}>${this.getDateData(index,'std')}</td>
              ${extra}
              <td ${strStyle}>${this.getAbs(index, 'absenceQty')}</td>
              <td ${strStyle}>${this.getAbsType(index, 'absenceCode')}</td>
              <td ${strStyleRemark}>${this.getDateRemark(index)}</td>
            </tr>`;
          }
        })

        return calendarHTML
      },
      getUnit(){
        let unit = ""
        if(this.timesheet.Unit.toLowerCase() === 'hour'){
          unit = "hrs"
        }
        if(this.timesheet.Unit.toLowerCase() === 'day'){
          unit = "days"
        }
        return unit;
      },
      getDateData(ind,col){
        let day = this.timesheet.Days.Days[ind];
        return parseFloat(day[col])+" "+this.getUnit()
      },
      getAbs(ind,col){
        let day = this.timesheet.Days.Days[ind];
        return parseFloat(day[col])+" "+((this.$store.getters['auth/scopeDefault']['is_absences_per_days'])?"day":"hrs")
      },
      getAbsType(ind,col){
        let day = this.timesheet.Days.Days[ind];
        return (day[col])
      },
      getDateRemark(ind){
        return (this.timesheet.Days.Days[ind].Remarks)?this.timesheet.Days.Days[ind].Remarks:"";
      },
      totalBlock(overTime){
        let blockStyle = "font-family: 'Verdana';width: 350px; font-size: 9px; margin-top: 2px"
        let spanStyle = 'style="font-weight: bolder"'
        let totalStr = `<div style="${blockStyle}">`
        if (this.commentTotal){
          totalStr+=`<div>NB: ${this.commentTotal}</div>`
        }

        let approverRejectionReason = ""
        let approver = this.timesheet.Approvers.find(ap=>ap.date!==null)
        if (approver){
          approverRejectionReason = approver.RejectionReason
        }

        if (approverRejectionReason){
          totalStr+=`<div>APPR: ${approverRejectionReason}</div>`
        }
        totalStr += `<div>TOTAL:</div>`
        totalStr += `<div> ${this.timesheet.Days.Types[0].std}: <span ${spanStyle}>${this.stdTotal} ${this.getUnit()}</span></div>`
        totalStr += overTime

        if (parseFloat(this.absenceTotal)>0){
          totalStr+=`<div>ABSENCES: <span ${spanStyle}>${this.absenceTotal} ${(this.$store.getters['auth/scopeDefault']['is_absences_per_days'])?"day":"hrs"}</span></div>`
        }
        totalStr+=`</div>`
        return totalStr
      },
      updateTimesheetCommentTotal(){
        this.timesheet.Notes = this.commentTotal;
      },
      isToDisplayOvertime(overtimeNb) {
        return this['ot'+overtimeNb+'Total'] !== "0.00" ;
      },
      calculateTotalHours() {
        this.stdTotal = 0;
        this.ot1Total = 0;
        this.ot2Total = 0;
        this.ot3Total = 0;
        this.timesheet.Days.Days.forEach(day => {
          this.stdTotal += +day.std;
          this.ot1Total += +day.ot1;
          this.ot2Total += +day.ot2;
          this.ot3Total += +day.ot3;
        });
        this.stdTotal = this.formatHours(this.stdTotal);
        this.ot1Total = this.formatHours(this.ot1Total);
        this.ot2Total = this.formatHours(this.ot2Total);
        this.ot3Total = this.formatHours(this.ot3Total);
      },
      calculateTotalAbsences(){
        this.absenceTotal = 0;
        this.timesheet.Days.Days.forEach(day => {
          if(day.absence === "1"){
            this.absenceTotal += parseFloat(day.absenceQty);
          }
        });
      },
      formatHours(time) {
        time = time.toString();
        if (!time.includes(".")) {
          time = time + ".00";
        }
        return time;
      },
      inputFileRecive(files){
        this.timesheet['Attachments'] = files;
      },
      getTimesheetConfig() {
        getTimesheetsConfig().then(
                config => {
                    this.timesheetsConfig = config.data;
                }

            )
        }
    },
    watch: {
      timesheet: {
        handler(){
          this.calculateTotalHours();
        },
        deep: true
      }
    },
    created() {
      this.getTimesheetConfig();
      this.overtimeTypes = this.timesheet.Days.Types[0];
      this.unit = this.timesheet.Unit;
      this.commentTotal = this.timesheet.Notes;
      this.calculateTotalHours();
      this.calculateTotalAbsences();
      this.timesheet['LanguageID'] =null;
      if(this.timesheet.Attachments.length>0){
        for(let i =0; i<this.timesheet.Attachments.length; i++){
          if(this.timesheet.Attachments[i][0]){
            this.oldAttachments.push({
              'FileName':this.timesheet.Attachments[i].FileName.split('_')[2],
              'FileBase64':this.timesheet.Attachments[i].FileBase64,
            })
          }else{
            this.oldAttachments.push(this.timesheet.Attachments[i]);
          }
        }
        this.timesheet.Attachments = this.oldAttachments;
        this.files = this.oldAttachments;
      }else{
        this.oldAttachments = [];
      }

      this.$v.$touch();
    }
  }
</script>

<style scoped>
  .tooltip.b-tooltip-secondary::v-deep .tooltip-inner {
    padding: 15px !important;
  }
</style>
